import Typography from "@material-ui/core/Typography";
import React from "react";
import {Grid} from "@material-ui/core";
import {format} from "date-fns";

export default function PropertyAddressViewTile({consumerData, showStatus}) {
    return (
        <>
        <Grid container spacing={2}> 
            <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" component="h2">
                Property Address
            </Typography>
            <b>
                <span>{consumerData?.addressLine1}</span>&nbsp;
                <span>{consumerData?.addressLine2}</span><br/>
                <span>{consumerData?.city}</span>, <span>{consumerData?.state}</span>, <span>{consumerData?.zip}</span>
            </b>
            </Grid>
            {consumerData?.startDate &&
            <>
            <Grid item xs={12} sm={6} md={4}> 
              Submitted Date: <br/>
              <b>{format(new Date(consumerData?.startDate), 'MM/dd/yyyy')}</b>
            </Grid>
            </>}
        </Grid>
        <Grid container spacing={2}> 
            <Grid item xs={12} sm={6} md={4}>
            {showStatus && 
            <>
            <Typography variant="h5" component="h2">
                Current Status
            </Typography>
            <b>
                <span>{consumerData?.userRequestStatus}</span>
            </b>
            </>}
            </Grid>
        </Grid>
        </>
    );
}
